import styled from 'styled-components'

const Text = styled.div`
  flex: 1 0 auto;
`

export default Text
